export function initNavigation(): void {
    const hamburger = document.querySelector<HTMLElement>('header .hamburger');
    const popover = document.getElementById('secondaryNavModal');
    const supportsPopover = 'popover' in HTMLElement.prototype;

    function closeNav(): void {
        hamburger?.classList.remove('is-active');
        popover?.classList.remove('is-open');
        popover?.querySelectorAll('.lds-nav__item.is-open').forEach((item) => {
            item.classList.remove('is-open');
        });
    }

    if (hamburger) {
        hamburger.addEventListener('click', () => {
            if (!supportsPopover && popover) {
                if (popover.classList.contains('is-open')) {
                    closeNav();
                } else {
                    hamburger.classList.add('is-active');
                    popover.classList.add('is-open');
                }
            } else {
                hamburger.classList.toggle('is-active');
            }
        });
    }

    if (popover) {
        if (supportsPopover) {
            popover.addEventListener('toggle', (event) => {
                if ((event as ToggleEvent).newState === 'closed') closeNav();
            });
        } else {
            popover.removeAttribute('popover');
            popover.querySelector('.hamburger')?.addEventListener('click', () => closeNav());
        }
    }

    popover?.querySelectorAll('.nav-item-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const navItem = toggle.closest('.lds-nav__item');

            popover.querySelectorAll('.lds-nav__item.is-open').forEach((item) => {
                if (item !== navItem) item.classList.remove('is-open');
            });

            navItem?.classList.toggle('is-open');
        });
    });
}
